import { computed, ref } from 'vue'

import { useClaudeTeamService } from '@/services/claude-team'
import { badgeText } from '@/services/my-work'

import { BADGE_POLL_MS } from './useMyWorkBadge'
import { usePollWhile } from './usePollWhile'

/** What the badge's hover says it counts. */
export const NEEDS_ATTENTION_BADGE_HELP =
  'Delivery checks that need a person: red or stuck builds, backmerges, missed release cuts and statuses that do not match'

/**
 * The side nav's Needs attention badge: how many delivery checks are listed, team-wide, from the same answer the
 * page reads. A fleet without the route, or one that cannot be reached, shows no badge.
 */
export function useNeedsAttentionBadge() {
  const isConfigured = Boolean(import.meta.env.VITE_FLEET_API_BASE_URL)
  const { useAttention } = useClaudeTeamService()
  const { data, refetch } = useAttention({ enabled: isConfigured })

  usePollWhile(ref(isConfigured), () => refetch(), BADGE_POLL_MS)

  const count = computed(() => data.value?.counts?.total ?? 0)
  const text = computed(() => badgeText(count.value))
  return { count, text }
}
